<div class="fpx-form-control">
    <fpx-label *ngIf="label" [control]="formControl" [label]="label"></fpx-label>
    <div class="fpx-field-content">
        <input matInput [maxlength]="maxLength" [minlength]="minLength" [formControl]="formControl" [ngClass]="{'input-available': formControl.value,'allow-paste': allowCopyPaste}" />
        <mat-placeholder *ngIf="placeholder" class="placeholder">{{ placeholder }}</mat-placeholder>
        <mat-hint class="hint-field" *ngIf="hint" [innerHtml]="hint"></mat-hint>
    </div>
    <mat-error *ngIf="formControl && formControl.invalid && formControl.touched && (customError == '')">
        {{ errorCode }}
    </mat-error>
    <mat-error *ngIf="customError != ''">
        {{ customError }}
    </mat-error>
</div>